import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router";
import {
  parseSalesStatisticsView,
  SalesStatisticsView,
  toSalesStatisticsParams,
} from "./salesStatisticsUrlState.ts";

export function useSalesStatisticsUrlState() {
  const [searchParams, setSearchParams] = useSearchParams();
  const view = useMemo(
    () => parseSalesStatisticsView(searchParams),
    [searchParams],
  );

  const changeView = useCallback(
    (change: Partial<SalesStatisticsView>) =>
      setSearchParams(
        (current) =>
          toSalesStatisticsParams({
            ...parseSalesStatisticsView(current),
            ...change,
          }),
        { replace: true },
      ),
    [setSearchParams],
  );

  return { view, changeView };
}
